import { SET_REVIEWS_ANALYSIS_RESULTS } from './actions';
import { isV2Format } from '../../utils/reviewsAdapter';

const initialState = {
  analysisData: null,
  url: null,
  v2Data: null, // Store the new format data separately
  dataVersion: null, // Track which version of data we have
  reviewsUrl: null, // Store the reviews URL for triggering analysis
  isApp: false // Store if the URL is for a mobile app
};

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REVIEWS_URL': {
      return {
        ...state,
        reviewsUrl: action.payload.reviewsUrl,
        isApp: action.payload.isApp
      };
    }
    case SET_REVIEWS_ANALYSIS_RESULTS: {
      const data = action.payload;

      // Check if we're dealing with v2 format
      if (data && isV2Format(data)) {
        return {
          ...state,
          v2Data: data, // Store v2 data separately
          url: data?.url,
          dataVersion: 'v2'
        };
      } else {
        // Handle old format as before
        return {
          ...state,
          analysisData: data,
          url: data?.url,
          dataVersion: 'v1'
        };
      }
    }
    default:
      return state;
  }
};

export default reviewsReducer;
